function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#E1E1E1",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30 0c16.57 0 30 13.43 30 30S46.57 60 30 60C13.431 60 0 46.57 0 30S13.431 0 30 0zm0 2.5C14.812 2.5 2.5 14.811 2.5 30S14.812 57.5 30 57.5c15.19 0 27.5-12.31 27.5-27.5S45.19 2.5 30 2.5zm14.967 15.846c.554-.555 1.476-.468 1.917.18 2.29 3.362 3.535 7.329 3.535 11.474 0 11.276-9.143 20.417-20.418 20.417-4.148 0-8.115-1.244-11.476-3.532-.648-.44-.735-1.363-.18-1.917zm.653 2.879L21.223 45.623c2.434 1.369 5.158 2.156 8 2.277l.778.017c9.894 0 17.918-8.022 17.918-17.918 0-3.118-.803-6.118-2.299-8.774zM30 9.584c4.147 0 8.111 1.243 11.476 3.531.648.441.735 1.363.18 1.918l-26.625 26.62c-.554.554-1.475.467-1.916-.18-2.289-3.355-3.533-7.322-3.533-11.472C9.582 18.726 18.726 9.584 30 9.584zm0 2.5c-9.895 0-17.918 8.023-17.918 17.917 0 2.863.673 5.622 1.936 8.101l.357.668 24.398-24.393-.67-.358c-2.258-1.148-4.743-1.808-7.325-1.919z"
})));

var SvgEmpty = function SvgEmpty(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty.fa1831b4.svg";
export { ForwardRef as ReactComponent };